import { DropdownOptionType } from '@Components/Dropdown/Type';
import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import { AppDispatch } from '@Store';

export const LogisticsOptions: DropdownOptionType[] = [
  { value: 'delhivery', display: 'Delhivery' },
  { value: 'bluedart', display: 'Bluedart' },
  { value: 'xpressbees', display: 'Xpressbees' },
  { value: 'ecom', display: 'Ecom' },
  { value: 'ekart', display: 'Ekart' },
];

export const PaymentModeOptions: DropdownOptionType[] = [
  { value: 'cod', display: 'COD' },
  { value: 'prepaid', display: 'Prepaid' },
];

export const ServiceTypeOptions: DropdownOptionType[] = [
  { value: 'air', display: 'Air' },
  { value: 'surface', display: 'Surface' },
];

export const OrderTypeOptions: DropdownOptionType[] = [
  { value: 'forward', display: 'Forward' },
  { value: 'reverse', display: 'Reverse' },
];

export interface IThinkLogisticsDomesticInformationSchema {
  csp: string;
  type: string;
  accountNo: string;
  pickup_address_id: string;
  logistics: string;
  order_type: string;
  s_type: string;
  payment_mode: string;
}
export const onForward = async ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
  setLoading,
}: {
  values: IThinkLogisticsDomesticInformationSchema;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  try {
    setLoading(true);

    const body: any = { ...JSON.parse(JSON.stringify(values)) };
    body.csp = 'ithink_logistics_domestic';

    for (const key in body) {
      if (body[key]) {
        if (key === 'accountNo') {
          if (Array.isArray(body[key])) {
            body[key] = body[key][0]?.value?.split('-')?.[0] || '';
          } else if (typeof body[key] === 'object' && body[key]?.value) {
            body[key] = body[key].value.split('-')?.[0] || '';
          } else if (typeof body[key] === 'string') {
            body[key] = body[key].split('-')?.[0];
          }
        }
      }
    }

    const response: any = await dispatch(
      postFedExDetails({
        shipmentNumber: `${shipmentNumber}`,
        body,
        date: null,
        nextFunc,
      }),
    );

    // call nextFunc only when success
    if (response.meta.requestStatus === 'fulfilled') {
      nextFunc();
    }
  } catch (error) {
    console.error('Error in onForward:', error);
  } finally {
    setLoading(false);
  }
};
